import '@vebox/etui-system';
import { createElement } from 'react';
import '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import CheckboxBase from './CheckboxBase.js';
import CheckboxCircle from './CheckboxCircle.js';
import './utils.js';

const Checkbox = props => /*#__PURE__*/createElement(CheckboxBase, props);
Checkbox.Circle = CheckboxCircle;

export default Checkbox;
